import angular from 'angular'
import select2 from './select2Directive'
import select2Query from './select2Factory'

export default angular
    .module('app.select2', [])
    .factory('select2Query', ['$timeout', select2Query])
    .directive('select2', ['select2Query', select2])
    .name



// WEBPACK FOOTER //
// ./src/components/select2/index.js